import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { map } from 'rxjs';
import { DeviceSessionMessageService } from 'src/app/services/device-session-message-service/device-session-message.service';
import { safeDismiss } from 'src/app/services/session-service/safe-dismiss';

@Component({
  selector: 'app-device-session-messages-popover',
  standalone: false,
  templateUrl: './device-session-messages-popover.component.html',
  styleUrls: ['./device-session-messages-popover.component.scss'],
})
export class DeviceSessionMessagesPopoverComponent {
  messages$ = this.deviceSessionMessageService.messages$.pipe(
    map((messages) => [...messages].reverse()),
  );

  constructor(
    private deviceSessionMessageService: DeviceSessionMessageService,
    private popoverController: PopoverController,
  ) {}

  async clearAll(): Promise<void> {
    this.deviceSessionMessageService.clearAll();
    await safeDismiss(this.popoverController);
  }

  formatTime(timestamp: Date): string {
    return timestamp.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }
}
